import { HelpTooltip } from "@/components/help-tooltip";
import { REPORTS, type ActiveGrafanaReport } from "@/lib/report-filters";

const REPORT_DESCRIPTIONS: Record<ActiveGrafanaReport, string> = {
  executive: "An overview of the selected substations and feeders.",
  performance: "Measurements and compliance observations for the selected feeder.",
  reliability: "Service and band observations for the selected substations.",
  "daily-dar": "Daily data availability for the selected feeders.",
};

export function ReportExplainer({ report }: { report: ActiveGrafanaReport }): JSX.Element {
  const title: string =
    REPORTS.find((definition) => definition.report === report)?.title ?? "report";
  return (
    <HelpTooltip label={`About ${title}`} text="About this report" className="">
      <span className="mb-2 block font-medium">{REPORT_DESCRIPTIONS[report]}</span>
      <span className="block">
        Times use Africa/Lagos (UTC+01:00). Reports use the selected monitored-feeder catalog.
      </span>
      <span className="mt-2 block">
        DAR reflects received telemetry samples. Missing telemetry is not proof of an outage.
      </span>
      <span className="mt-2 block">
        Reports show only history retained in Cloud SQL. A longer range can include dates with
        no retained data.
      </span>
    </HelpTooltip>
  );
}
